import { Button } from "@mui/material";
import { PlayArrow as PlayArrowIcon } from "@mui/icons-material";
import { 
  getCommonHeadCellProps, 
  getCommonBodyCellPropsTradesPositions 
} from "./commonUtils";

export const getGenevaReportsColumns = (theme, runningReports, handleRunReport) => {
  const commonHeadCellProps = getCommonHeadCellProps(theme);
  const commonBodyCellProps = getCommonBodyCellPropsTradesPositions(theme);
  
  return [
    {
      accessorKey: "ReportAlias",
      header: "Report Alias",
      size: "20%",
      muiTableHeadCellProps: {
        ...commonHeadCellProps,
        sx: {
          ...commonHeadCellProps.sx,
          width: "20%",
          maxWidth: "20%",
        },
      },
      muiTableBodyCellProps: {
        ...commonBodyCellProps,
        sx: {
          ...commonBodyCellProps.sx,
          width: "20%",
          maxWidth: "20%",
        },
      },
      Cell: ({ cell }) => (
        <span
          style={{
            fontWeight: 600,
            color: theme.palette.primary.main,
            fontSize: "0.8rem",
          }}
        >
          {cell.getValue()}
        </span>
      ),
    },
    {
      accessorKey: "ReportParameters",
      header: "Report Parameters",
      size: "30%",
      muiTableHeadCellProps: {
        ...commonHeadCellProps,
        sx: {
          ...commonHeadCellProps.sx,
          width: "30%",
          maxWidth: "30%",
        },
      },
      muiTableBodyCellProps: {
        ...commonBodyCellProps,
        sx: {
          ...commonBodyCellProps.sx,
          width: "30%",
          maxWidth: "30%",
          whiteSpace: "normal",
          verticalAlign: "top",
        },
      },
      Cell: ({ cell }) => {
        const params = cell.getValue();
        try {
          const parsedParams = typeof params === 'string' ? JSON.parse(params) : params;
          if (Array.isArray(parsedParams)) {
            // Sort parameters alphabetically by Name
            const sortedParams = [...parsedParams].sort((a, b) => {
              const nameA = (a.Name || '').toLowerCase();
              const nameB = (b.Name || '').toLowerCase();
              return nameA.localeCompare(nameB);
            });
            
            return (
              <div>
                {sortedParams.map((param, index) => (
                  <div
                    key={index}
                    style={{
                      fontSize: "0.8rem",
                      lineHeight: 1.4,
                      marginBottom: "3px",
                      color: theme.palette.text.secondary,
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 600,
                        color: theme.palette.text.primary,
                      }}
                    >
                      {param.Name}:
                    </span>{" "}
                    <span style={{ fontWeight: 400 }}>
                      {param.Value || param.value}
                    </span>
                  </div>
                ))}
              </div>
            );
          }
          return (
            <div
              style={{
                fontFamily: "monospace",
                fontSize: "0.8rem",
                color: theme.palette.text.secondary,
              }}
            >
              {JSON.stringify(parsedParams, null, 2)}
            </div>
          );
        } catch (error) {
          return (
            <div
              style={{
                fontFamily: "monospace",
                fontSize: "0.8rem",
                color: theme.palette.error.main,
              }}
            >
              {String(params)}
            </div>
          );
        }
      },
    },
    {
      accessorKey: "RunCommand",
      header: "",
      size: "50%",
      muiTableHeadCellProps: {
        ...commonHeadCellProps,
        sx: {
          ...commonHeadCellProps.sx,
          width: "50%",
          maxWidth: "50%",
        },
      },
      muiTableBodyCellProps: {
        ...commonBodyCellProps,
        sx: {
          ...commonBodyCellProps.sx,
          width: "50%",
          maxWidth: "50%",
          textAlign: "left",
        },
      },
      Cell: ({ row }) => {
        const reportAlias = row.original.ReportAlias;
        const isRunning = runningReports.has(reportAlias);
        
        return (
          <Button
            variant="contained"
            size="small"
            startIcon={<PlayArrowIcon />}
            onClick={() => handleRunReport(reportAlias)}
            disabled={isRunning}
            sx={{
              fontSize: "0.8rem",
              padding: "2px 8px",
              minWidth: "80px",
              backgroundColor: isRunning 
                ? theme.palette.grey[400] 
                : theme.palette.success.main,
              color: isRunning 
                ? theme.palette.grey[600] 
                : theme.palette.success.contrastText,
              "&:hover": {
                backgroundColor: isRunning 
                  ? theme.palette.grey[500] 
                  : theme.palette.success.dark,
              },
              "&:disabled": {
                backgroundColor: theme.palette.grey[400],
                color: theme.palette.grey[600],
              },
            }}
          >
            {isRunning ? "Running..." : "Run"}
          </Button>
        );
      },
    },
  ];
};
